import React, { useContext, useEffect, useState } from "react";
import { DialogContext } from "../context/DialogContext";
import { SiteSettingsContext } from "../context/SiteSettingsContext";
import useTranslations from "../hooks/useTranslations";
import { CardLink } from "./CardLink";

export const MarketSelectorDialog = () => {
  const { state, dispatch } = useContext(DialogContext);
  const { markets } = useContext(SiteSettingsContext);

  const translations = useTranslations();

  // Ensure that we don't load flags and other assets until this
  // dialog has been opened at least once. Also don't re-render
  // everything if it is opened multiple times on the same page
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    if (state.marketSelector) {
      setHasOpened(true);
    }
  }, [state.marketSelector]);

  if (!state || !markets?.length) {
    return null;
  }

  return (
    <div
      onClick={() => dispatch({ type: "marketSelector.close" })}
      className={`dialog-backdrop ${
        state.marketSelector ? "dialog-backdrop-active" : "dialog-backdrop-inactive"
      }`}
    >
      <div
        className="dialog"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <h2>{translations.chooseCountry}</h2>
        <ul className="flex flex-wrap lg:justify-start lg:-mx-4 overflow-y-auto">
          {hasOpened &&
            markets.map((market, index) => {
              const flagUrl = `https://flagcdn.com/${market.flagId}.svg`;

              return (
                <li key={index} className="w-full lg:w-6/12 xl:w-4/12 lg:px-4 mb-6">
                  <CardLink
                    title={market.title}
                    href={market.url}
                    imgUrl={flagUrl}
                    imgRole="presentation"
                    imgWidth={18}
                    imgHeight={18}
                  />
                </li>
              );
            })}
        </ul>
      </div>
    </div>
  );
};
